import { WizTranslationManager } from '../../services/translation/wiz-translation.manager';
import { WizDndManager } from '../../services/dragndrop/wiz-dnd.manager';
import {
  Directive,
  Input,
  ElementRef,
  HostListener,
  Renderer2,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[wizTooltip]',
})
export class WizTooltipDirective implements OnDestroy {
  @Input() wizTooltip: string = null;
  @Input() tooltipPlacement: string = 'top';
  @Input() tooltipEnable: boolean = true;
  @Input() tooltipEnableFunc: Function = null;
  @Input() tooltipShowDelay: number = 50; // délai d'apparition du tooltip en ms
  // private _displayed: boolean = false;
  // tooltip: HTMLElement;
  offset = 10;

  public static tooltip: HTMLElement; // LMA fix... unicité de tooltip
  public static target: Renderer2;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    if (this.renderer !== WizTooltipDirective.target && !!this.wizTooltip) {

      let enabled: boolean = this.tooltipEnable;
      if (
        this.tooltipEnableFunc !== null &&
        this.tooltipEnableFunc !== undefined
      ) {
        enabled = this.tooltipEnableFunc();
      }
      if (enabled) {
        this.show();
      }
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.hide();
  }

  @HostListener('mousedown')
  onMouseDown() {
    this.hide();
  }

  show() {
    if (!WizDndManager.isActive()) {
      // this._displayed = true;
      if (this.tooltipShowDelay > 0) {
        setTimeout(() => this._show(), this.tooltipShowDelay);
      } else {
        this._show();
      }
    }
  }

  private _show() {
    // if (this._displayed) {
      this.create();
      this.setPosition();
      this.renderer.addClass(WizTooltipDirective.tooltip, 'ng-tooltip-show');
    // }
  }

  hide() {
    if (WizTooltipDirective.tooltip) {
      WizTooltipDirective.target.removeClass(WizTooltipDirective.tooltip, 'ng-tooltip-show');
      WizTooltipDirective.target.removeChild(document.body, WizTooltipDirective.tooltip);
      WizTooltipDirective.tooltip = null;
      WizTooltipDirective.target = null;
    }
  }

  create() {

    this.hide(); // on rince l'éventuel précédent
    WizTooltipDirective.target = this.renderer;
    WizTooltipDirective.tooltip = this.renderer.createElement('span');

    let realText: string = WizTranslationManager.getInstance().translateKey(this.wizTooltip, null, null);
    if (realText.length > 2000) {
      realText = realText.substring(0, 1999) + '...';
    }

    this.renderer.setProperty(WizTooltipDirective.tooltip, 'innerHTML', realText);

    this.renderer.appendChild(document.body, WizTooltipDirective.tooltip);
    this.renderer.addClass(WizTooltipDirective.tooltip, 'wiz-tooltip');
  }

  setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const tooltipPos = WizTooltipDirective.tooltip.getBoundingClientRect();

    const scrollPos =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    let top, left;

    if (this.tooltipPlacement === 'top') {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.tooltipPlacement === 'bottom') {
      top = hostPos.bottom + this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.tooltipPlacement === 'left') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.left - tooltipPos.width - this.offset;
    }

    if (this.tooltipPlacement === 'right') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.right + this.offset;
    }
    this.renderer.setStyle(WizTooltipDirective.tooltip, 'top', `${top + scrollPos}px`);
    this.renderer.setStyle(WizTooltipDirective.tooltip, 'left', `${left}px`);
  }

  ngOnDestroy(): void {
    this.hide();
  }
}
